module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('m-header', {
    attrs: {
      "title": "酒币兑换"
    }
  }, [_c('router-link', {
    staticClass: "fr",
    attrs: {
      "slot": "right",
      "tag": "div",
      "to": "/userCenter/wineMoney/rules"
    },
    slot: "right"
  }, [_vm._v("规则")])], 1), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('h1', [_vm._v(_vm._s(_vm.data.avail_num) + "个")]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('span', {
    staticClass: "flex-1 text-l"
  }, [_vm._v("小酒币，有大用，多攒一些存起来")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.withdrawal
    }
  }, [_vm._v("提现")])])]), _vm._v(" "), _c('div', {
    staticClass: "contont"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.data.sign_list), function(item) {
    return _c('div', {
      staticClass: "flex list"
    }, [_c('div', {
      staticClass: "l flex-1 text-l"
    }, [_c('span', [_vm._v(_vm._s(item.type))]), _vm._v(" "), _c('p', {
      staticClass: "color-666"
    }, [_vm._v(_vm._s(_vm._f("createTimer")(item.create_time)))])]), _vm._v(" "), _c('div', {
      staticClass: "fr"
    }, [_vm._v("\n                " + _vm._s(item.coin_num) + "\n            ")])])
  })], 2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title flex "
  }, [_c('span', {
    staticClass: "flex-1 text-l"
  }, [_vm._v(" 酒币收支明细")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-89bb8e02"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserCenter/wineMoney/wineMoney.vue
// module id = 594
// module chunks = 0